import React, { useMemo } from "react";
import { Navigate, useMatch } from "react-router-dom";

import ComponentLoader from "../../../../components/Spinner/ComponentLoader";
import SurveysTabLayout from "./components/SurveysTabLayout";

import { useRbacPrimaryRolePermissions } from "../../../../api/hooks";
import { useCurrentUser } from "../../../../api/hooks/defs/auth";
import { useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

import ErrorPage from "../../../Error";
import { getSurveysNavLinks } from "./config";

const Surveys = () => {
	const matchAllSurveys = useMatch("/surveys");
	const matchMySurveys = useMatch("/surveys/my-surveys");

	const {
		value: ffSurveys,
		query: { isLoading: isLoadingFFSurveys },
	} = useFeatureFlagQuery("ff-is-surveys-enabled", false);
	const { data: rbacPermissions, isLoading: isLoadingRbacPermissions } = useRbacPrimaryRolePermissions("surveys");

	const { data: currentUser } = useCurrentUser();
	const currentUserId = currentUser?.me?.authorization?.payload?.user_id;
	const userId = currentUserId ?? "";
	const mySurveysFilters = useMemo(() => (userId ? { created_user_id_eq: userId } : undefined), [userId]);

	const isLoading = isLoadingFFSurveys || isLoadingRbacPermissions;

	if (isLoading) {
		return <ComponentLoader />;
	}

	if (!ffSurveys) {
		return <ErrorPage code={403} />;
	}

	const canViewAllSurveys = rbacPermissions?.includes("surveys:view");

	if (!canViewAllSurveys && matchAllSurveys) {
		return <Navigate to="/surveys/my-surveys" replace />;
	}

	const canCreateSurvey = rbacPermissions?.includes("surveys:create");
	const navLinks = getSurveysNavLinks(rbacPermissions ?? []);

	return (
		<div className="border-t-[1px] border-solid border-neutral-2">
			{matchAllSurveys && (
				<SurveysTabLayout
					navLinks={navLinks}
					activeNavigationLinkKey="all-surveys"
					showCreateButton
					showDeleteOption
					showFilter={true}
					refetchOnMount
				/>
			)}
			{matchMySurveys && (
				<SurveysTabLayout
					navLinks={navLinks}
					activeNavigationLinkKey="my-surveys"
					showCreateButton={canCreateSurvey}
					showDeleteOption
					showFilter={false}
					extraFilters={mySurveysFilters}
					disabled={!userId}
				/>
			)}
		</div>
	);
};

export default Surveys;
